export default __webpack_public_path__ + "static/media/cop1.63ea4b14.png";